export const TELEGRAM_LINK = 'https://t.me/empmoney';
export const TWITTER_LINK = 'https://x.com/EmpFusion';
export const YOUTUBE_LINK =
  'https://www.youtube.com/playlist?list=PL2ZUX77BqsmWkeOisjYEIeIWs6egmmVBd';
export const DISCORD_LINK = 'https://discord.gg/dexfinance';
export const MOTHERSHIP_LINK = 'https://mothershipdefi.com/';
